export default __webpack_public_path__ + "static/media/support_dark_mode.074eb105.svg";